import { Component, Inject, LOCALE_ID } from '@angular/core';
import { Router } from '@angular/router';
import { version } from '../../package.json';
import { UserService } from '../services/user/user.service';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { applyZendeskClickHook } from 'src/utils/autofillZendesk';
import { SessionStorageService } from 'src/services/session-storage/session-storage.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {

  public packageVersion = version;

  constructor(
    public readonly router: Router,
    @Inject(LOCALE_ID) public locale: string,
    private userService :UserService,
    private authenticationService: AuthenticationService,
    private sessionStorage: SessionStorageService
  ) {
    applyZendeskClickHook(sessionStorage);
  }

  scrollToTopClick() {
    window.scrollTo(0, 0);
  }

  async changeLanguage(lang) {
    console.log(lang, this.locale);
    if (lang != this.locale.substr(0,2)) {
      if(this.authenticationService.isLoggedIn()) {
        await this.userService.patchParams([{key:'language', value:lang}]);
      }
      var changeLocale = lang != 'en' ? `/${lang}` : '';
      var path = this.locale.substr(0,2)=='en'?window.location.pathname:window.location.pathname.substr(3);
      console.log(changeLocale);
      if (window.location && window.location.pathname !== "/") {
        console.log(changeLocale, path);
        window.location.pathname=`${changeLocale}${path}`;
      }else{
        window.location.pathname= `${changeLocale}`;
      }
    }
  }

  getPortugueseLink() {
    if (!window.location || typeof window.location.pathname !== "string") {
      return "/pt/";
    } else if (window.location.pathname !== "/") {
      if (window.location.pathname.startsWith("/pt/")) {
        return window.location.pathname;
      } else {
        return `/pt${window.location.pathname}`;
      }
    }
    return "/pt/";
  }

  getEnglishLink() {
    if (!window.location || typeof window.location.pathname !== "string") {
      return "/";
    } else if (window.location.pathname !== "/" && window.location.pathname.startsWith("/pt/")) {
      return `/${window.location.pathname.substring(4)}`;
    }
    return window.location.pathname;
  }

  getTermsOfServiceDocUrl() {
    if (this.locale.toLowerCase().substring(0, 2) === "pt") {
      return "/assets/ReportsFeedContractPortugues.pdf";
    }
    return "/assets/ReportsFeedContractEnglish.pdf";
  }
  //
}
